export default __webpack_public_path__ + "static/media/ring.82ea90d3.less";